"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var MenuBadge = function MenuBadge(_ref) {
  var className = _ref.className,
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? 'new' : _ref$use,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "use", "children"]);
  return _react.default.createElement(_UIBadge.default, Object.assign({
    use: use,
    className: (0, _classNames.default)('m-left-2', className)
  }, rest), children);
};

var _default = MenuBadge;
exports.default = _default;
module.exports = exports.default;